// extracted by mini-css-extract-plugin
export var container = "_q4-0";
export var dotAnimation = "_q4-2";
export var dotsLoading = "_q4-1";